import { create } from "zustand";

// What the buyer sees after paying (see Services/purchaseTracker.js and
// Components/PurchaseStatusBanner.jsx). Deliberately not persisted: the pending
// purchase itself is remembered in localStorage by the tracker, so a refresh
// resumes it and rebuilds this state.
const usePurchaseStatusStore = create((set) => ({
  status: "idle", // "idle" | "processing" | "success" | "delayed" | "failed"
  title: "",
  message: "",
  reference: null,
  // When set, the banner offers "Email us" / "Copy email" for this address.
  contactEmail: null,
  show: (next) => set({ message: "", reference: null, contactEmail: null, ...next }),
  clear: () => set({ status: "idle", title: "", message: "", reference: null, contactEmail: null }),
}));

export default usePurchaseStatusStore;
